import { makeStyles } from '@rbx/ui';
import styles from '../../shared/utils/styles';

const useHomePageTopicCardStyles = makeStyles()(() => ({
  container: {
    height: 406,
    cursor: 'pointer',
    padding: '0 8px',
  },

  title: {
    marginBottom: 8,
    textAlign: 'center',
    width: '100%',
    ...styles.textClamp(),
  },

  image: {
    height: 250,
    width: 250,
    objectFit: 'cover',
    marginBottom: 16,
    borderRadius: '50%',
    overflow: 'hidden',
  },

  description: {
    flex: 1,
    marginBottom: 8,
    overflow: 'hidden',
  },
}));

export default useHomePageTopicCardStyles;
